/* eslint-disable no-unused-vars */
import React, { useMemo } from "react";
import { useTable, usePagination } from "react-table";
import "./table.css";

const PaginatedComponent = ({ columns = [], data = [], pageSize = 20, emptyMessage = "No data found" }) => {
  const memoizedColumns = useMemo(() => columns || [], [columns]);
  const memoizedData = useMemo(() => data || [], [data]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow
  } = useTable(
    {
      columns: memoizedColumns,
      data: memoizedData,
      initialState: { pageIndex: 0, pageSize: pageSize || 50 }
    },
    usePagination
  );

  const { pageIndex, pageSize: currentPageSize } = state;

  return (
    <>
      <div style={{ overflowX: "auto", width: "100%", backgroundColor: "#FFFFFF", height: "60vh" }}>
        <table {...getTableProps()} className="custom-table w-100 mb-0">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th className="table-border" {...column.getHeaderProps()} style={{ backgroundColor: "#F8FAFC" }}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page && page.length > 0 ? (
              page.map((row) => {
                prepareRow(row);

                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()}>
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  colSpan={memoizedColumns?.length || 10}
                  style={{
                    textAlign: "center",
                    padding: "45px 20px",
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <div className="d-flex flex-column align-items-center justify-content-center" style={{ gap: "10px" }}>
                    <i className="fas fa-search" style={{ fontSize: "38px", color: "#CBD5E1" }}></i>
                    <span style={{ fontSize: "15px", fontWeight: 600, color: "#64748B" }}>{emptyMessage}</span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {(memoizedData && memoizedData.length > 0) && (
        <div className="py-3 px-3 d-flex flex-wrap justify-content-between align-items-center bg-white border-top" style={{ gap: "10px" }}>
          <div className="d-flex align-items-center" style={{ gap: "8px", fontSize: "13px", color: "#64748B" }}>
            <span>Show</span>
            <select
              value={currentPageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
              className="form-control form-control-sm"
              style={{ width: "80px", borderRadius: "8px", border: "1px solid #CBD5E1", fontSize: "13px" }}
            >
              {[10, 25, 50, 100].map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
            <span>entries per page (Total: {memoizedData.length})</span>
          </div>

          <div className="d-flex align-items-center" style={{ gap: "6px" }}>
            <button
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
              className="btn btn-sm btn-outline-secondary"
              style={{ borderRadius: "8px", padding: "4px 10px", fontSize: "12px" }}
            >
              {"<<"}
            </button>
            <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className="btn btn-sm text-white font-weight-bold"
              style={{ backgroundColor: canPreviousPage ? "#F97316" : "#94A3B8", borderColor: "transparent", borderRadius: "8px", padding: "4px 12px", fontSize: "12px" }}
            >
              Previous
            </button>

            <span style={{ fontSize: "13px", fontWeight: 600, color: "#0F172A", margin: "0 8px" }}>
              Page {pageIndex + 1} of {pageOptions.length || 1}
            </span>

            <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className="btn btn-sm text-white font-weight-bold"
              style={{ backgroundColor: canNextPage ? "#F97316" : "#94A3B8", borderColor: "transparent", borderRadius: "8px", padding: "4px 12px", fontSize: "12px" }}
            >
              Next
            </button>
            <button
              onClick={() => gotoPage((pageCount || 1) - 1)}
              disabled={!canNextPage}
              className="btn btn-sm btn-outline-secondary"
              style={{ borderRadius: "8px", padding: "4px 10px", fontSize: "12px" }}
            >
              {">>"}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export const Paginated = React.memo(PaginatedComponent);
